import type { ValidationError } from './types'
import type { ArchivierungLoeschungAnonymisierung } from '@/types/studyTypes'

export function validateArchivierung(d: ArchivierungLoeschungAnonymisierung): ValidationError[] {
  const errors: ValidationError[] = []

  if (!d.loeschfrist) errors.push({ field: 'loeschfrist', message: 'Bitte Löschfrist wählen.' })

  if (d.loeschfrist === 'sonstige' && !d.loeschfristSonstige?.trim())
    errors.push({ field: 'loeschfristSonstige', message: 'Bitte Löschfrist beschreiben.' })

  if (!d.aalPersonenbezogeneDaten)
    errors.push({
      field: 'aalPersonenbezogeneDaten',
      message: 'Bitte Option zur Archivierung wählen.',
    })

  return errors
}
